// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Ln79","horizontal-swipe":"_1sN5A","no-scroll":"P99A0","shake":"_1F6XY"};